"use client";
import dynamic from "next/dynamic";
import { MSProductWithFullDetailWithVaraintPreset } from "@/util/query/product-query";
import ProductPromotionImageGallery from "./product-promotion-gallery";
import { toPriceString } from "@/util/toPriceString";
import { useState } from "react";
const ProductPromotionHeaderDetail = dynamic(() => import("./product-promotion-header-details"), { ssr: false });

const ProductPromotionHeader = ({
    product,
    text,
    imagePriority,
    loc,
    shopCurrency,
    enableCompareButton = false,
}: {
    product: MSProductWithFullDetailWithVaraintPreset;
    text: { [key: string]: string };
    imagePriority?: boolean;
    loc: string;
    shopCurrency: string;
    enableCompareButton: boolean;
}) => {
    const defaultVariantIndex = 0;

    const [imageUrl, setImageUrl] = useState<string | null>(
        product.productVariant.length > 0
            ? product.productVariant[defaultVariantIndex].featuredImageUrl
            : product.featuredImageUrl,
    );
    const imageIndex = product.imagesUrl.findIndex((image) => image === imageUrl);
    const imageAlt = product.imagesAlt[imageIndex] || `product-${product.id}`;
    
    const [weight, setWeight] = useState<number>(
        product.productVariant.length > 0 ? product.productVariant[defaultVariantIndex].weight : 0,
    );

    const handleOnSelectedVariantIndex = (index: number) => {
        const image = product.productVariant[index].featuredImageUrl;
        setImageUrl(image);
        const weight = product.productVariant[index].weight;
        setWeight(weight);
    };

    const [isload, setIsload] = useState(false);

    return (
        <div className="md:flex justify-start md:items-start p-2 gap-5 rounded-2xl my-2">
            <ProductPromotionImageGallery
                imageUrl={imageUrl}
                weightshow={toPriceString(weight ?? 0)}
                text={text}
                imagePriority={imagePriority}
                imageAlt={imageAlt}
            />
            <div className="mt-5 md:mt-0"></div>
            <div className={isload ? "w-full sm: min-h-500" : "w-full min-h-500"}>
                <ProductPromotionHeaderDetail
                    product={product}
                    onSelectedVariantIndex={handleOnSelectedVariantIndex}
                    onLoad={() => setIsload(true)}
                    text={text}
                    loc={loc}
                    shopCurrency={shopCurrency}
                    enableCompareButton={enableCompareButton}
                />
            </div>
        </div>
    );
};

export default ProductPromotionHeader;
